{
  "categories": {
    "certificates": "Certificados",
    "dashboard": "Painel de Controle",
    "dataTransfer": "Transferência de Dados",
    "other": "Outro",
    "products": "Produtos",
    "suppliers": "Fornecedores"
  },
  "title": "FAQ"
}
